import { render } from "./GiftEditView.vue?vue&type=template&id=b84e8844"
import script from "./GiftEditView.vue?vue&type=script&lang=js"
export * from "./GiftEditView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__